import preset from 'jss-preset-default';
import important from './jss-important';

/**
 * Modern JSS Preset configuration.
 * Uses 'jss-preset-default' to load all standard plugins (nested, extend, camelCase, etc.)
 * and appends the custom 'important' plugin at the end to ensure it overrides others.
 */
export default (options: any = {}) => {
  // Initialize the default preset with options.
  // This returns an object: { plugins: [ ...list of standard plugins... ] }
  const defaultPreset = preset(options);

  return {
    plugins: [
      ...defaultPreset.plugins,
      // Add custom 'important' plugin last
      important(options.important),
    ],
  };
};